export const FETCH_TAB_CELL = 'FETCH_TAB_CELL';
export const DUMMY_ACTION = 'DUMMY_ACTION';
